import {
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initUserSlice,
  setPropertiesUser,
  updateUser,
} from "../Slices/user.slice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { Dropdown } from "antd";
import routes from "../../../engine/routes";
import {
  diplomas,
  languagesList,
  levels,
  listRoles,
  modeInterpretariat,
  roles,
  userStatusSelect,
} from "../../../utils/constants";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import { countryList } from "../../../utils/listsLabels";
import { UserContext } from "../../../engine/context/User.context";
import dayjs from "../../../utils/dayjs";
import { http } from "../../../engine/api/http";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { HiOutlineMail } from "react-icons/hi";

const { Content, Sider, Header, Footer } = Layout;

export function UserDetail({ unitId, expanded, onClose }) {
  const { id } = useParams();
  const { user, loading } = useSelector(state => state.userControl);

  const { init, clear } = initUserSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [ready, setReady] = useState(false);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const {
    info: { firstname, lastname, genre, phone },
    status,
    comment,
    email,
    subRoles,
    role,
  } = user;

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "Nom",
          name: "info.lastname",
          value: lastname,
          capitalize: true,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: "Prénom",
          name: "info.firstname",
          value: firstname,
          capitalize: true,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: "E-mail",
          name: "email",
          normalize: value => value && value.toLowerCase(),
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: "Téléphone",
          name: "phone",
          value: phone,
          type: "input",
          col: 24,
        },
        {
          label: "Remarque",
          name: "comment",
          value: comment,
          type: "textarea",
          col: 24,
        },
      ],
    },
    {
      parentLabel: userHasLevel({
        not: {
          [roles.user]: "r", //
        },
      })
        ? "Actions"
        : "",
      children: [
        {
          label: "Roles",
          name: "role",
          value: role,
          disabled: true,
          required: true,
          type: "select",
          selectContent: listRoles,
          col: 24,
        },
        {
          label: "Accès autorisé",
          name: "status",
          value: status,
          required: true,
          disabled: true,
          visible: userHasLevel({
            not: {
              [roles.user]: "r", //
            },
          }),
          type: "select",
          selectContent: userStatusSelect(),
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: id === "new" ? "Créer l'interprète" : "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];

  const onSubmitForm = async data => {
    if (id === "new") {
      data.role = roles.user;
    }

    await dispatch(setPropertiesUser(data));
    dispatch(updateUser());
  };

  const sendEmail = async () => {
    let caller = await http.post("/notifications/invitation", { userId: id });
    caller.status === 200 &&
      notification.success({
        message: `Email envoyé avec succès`,
      });
  };

  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.users(id).detail.title}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <ActionDropdown
            rule={{
              only: {
                [roles.admin]: "crud",
                [roles.permanance]: "crud",
              },
            }}
          >
            <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
              <a onClick={sendEmail}>Envoyer un email d'invitation</a>
            </ActionRoleSpecific>
          </ActionDropdown>

          <CustomForm
            disabled={true}
            initialValues={user}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
